export default {"src":"/_next/static/media/getOfferIconPassive.a44aacfe.svg","height":62,"width":62,"blurWidth":0,"blurHeight":0};